export class Controller {

    /** @ngInject */
    constructor($location, Alert, HardTokenService) {
        this.$location = $location;
        this.Alert = Alert;
        this.HardTokenService = HardTokenService;
    }

    $onInit() {
        this.generatedUrl = '';
        this.otps = {otp1: '', otp2: '', otp3: ''};
    }

    generateUrl() {
        this.isGeneratingUrl = true;
        this.HardTokenService
            .generateSyncUrl(this.resolve.token)
            .then(({trackerId}) => this.generatedUrl =
                this.$location.absUrl().replace(/#.*/, `#/htsync/${trackerId}`)
            )
            .finally(() => this.isGeneratingUrl = false)
    }

    sync() {
        this.isSyncing = true;
        this.HardTokenService
            .sync(this.resolve.token, this.otps)
            .then(() => this.Alert('success', 'company.hard-token-management.sync.synced'))
            .catch(() => this.Alert('danger', 'company.hard-token-management.sync.failed'))
            .finally(() => this.isSyncing = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-sync/hard-token-sync.controller.js